import { type FC, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { useAppSelector } from '../../../store/hooks'
import { selectAccountId } from '../../../store/auth/authSlice'
import { ContactAccountIntake } from './ContactAccountIntake'
import { OpeningsEntryPanel } from './OpeningsEntryPanel'
import { useAccountTypeCatalog } from '../hooks/useAccountTypeCatalog'
import { useAccountOpeningConnectors } from '../hooks/useAccountOpeningConnectors'

interface ContactAccountsSectionProps {
  contactId: string
  contactName: string
}

export const ContactAccountsSection: FC<ContactAccountsSectionProps> = ({ contactId, contactName }) => {
  const accountId = useAppSelector(selectAccountId)
  const navigate = useNavigate()

  const { connectors } = useAccountOpeningConnectors()
  const catalog = useAccountTypeCatalog(accountId, connectors[0] ?? '')

  const [showIntake, setShowIntake] = useState(false)

  const openFlow = (params: Record<string, string>) => {
    navigate(`/workspace/account-opening?${new URLSearchParams({ contactId, ...params })}`)
  }

  return (
    <>
      <OpeningsEntryPanel
        accountId={accountId}
        connectors={connectors}
        contactId={contactId}
        catalog={catalog}
        onOpenNew={() => setShowIntake(true)}
        onResume={(openingId) => openFlow({ openingId })}
        onView={(openingId) => openFlow({ openingId, mode: 'view' })}
        busyOpeningId={null}
      />

      {showIntake ? <ContactAccountIntake contactId={contactId} contactName={contactName} onCancel={() => setShowIntake(false)} /> : null}
    </>
  )
}
